export const INREVIEWSTATUS='IN REVIEW';
export const READYTOPUBLISHSTATUS= 'READYTOPUBLISH';
export const EXPIRED= 'Expired';
export const EXPIRINGSOON = 'Expiring Soon';
export const ACTIVE = 'Active';
export const PAGE = '1';
export const PER_PAGE = '10';